/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ex_TitleInputs */

const en_sorter_ex_title = /** @type {(inputs: Sorter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting a nested object`)
};

const ko_sorter_ex_title = /** @type {(inputs: Sorter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체 정렬하기`)
};

const ja_sorter_ex_title = /** @type {(inputs: Sorter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトを並べ替える`)
};

/**
* | output |
* | --- |
* | "Sorting a nested object" |
*
* @param {Sorter_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ex_title = /** @type {((inputs?: Sorter_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ex_title(inputs)
	if (locale === "ko") return ko_sorter_ex_title(inputs)
	return ja_sorter_ex_title(inputs)
});